import React, { FC, ReactElement } from 'react'
import { Route, Redirect } from 'react-router-dom'

interface Props {
  isAuthenticated: boolean
  component: ReactElement
  path: string
}

const PrivateRoute: FC<Props> = ({ isAuthenticated, path, component }) => (
  <Route
    path={path}
    render={({ location }): ReactElement => {
      if (isAuthenticated) {
        return component
      }

      return (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: location },
          }}
        />
      )
    }}
  />
)

export default PrivateRoute
